import { Box } from '@palmetto/palmetto-components';
import { useEffect } from 'react';
import { NavLink, useNavigate, useParams } from 'react-router-dom';

import { ProgramType, WarrantyType, warrantyMap } from 'types';

import { ContractSkus } from './ContractSkus';
import { Warranty } from './Warranty';

export const Warranties = () => {
  const navigate = useNavigate();
  const { programType = ProgramType.hvac, warrantyType } = useParams<{
    programType: string;
    warrantyType: string;
  }>();
  useEffect(() => {
    if (!warrantyType) {
      const warrantyKey = Object.keys(warrantyMap[programType as ProgramType])[0] as WarrantyType;
      navigate(`${warrantyKey}`);
    }
  }, [warrantyType, navigate, programType]);

  return (
    <Box direction="row" childGap="3xl">
      <Box>
        {Object.keys(warrantyMap[programType as ProgramType]).map((type) => (
          <NavLink
            to={`/admin/pricing/${programType}/warranties/${type}`}
            style={{ textDecoration: 'none', fontWeight: '500' }}
            key={type}
            end
          >
            {({ isActive }) => (
              <Box
                as="span"
                padding="md"
                className={isActive ? 'tab-active' : ''}
                hover={{ color: 'primary' }}
                style={{ transitionDuration: '0s', borderBottom: 0 }}
              >
                {warrantyMap[programType as ProgramType][type as WarrantyType]}
              </Box>
            )}
          </NavLink>
        ))}
        <NavLink
          to={`/admin/pricing/${programType}/warranties/contract-skus`}
          style={{ textDecoration: 'none', fontWeight: '500' }}
          key="contract-skus"
          end
        >
          {({ isActive }) => (
            <Box
              as="span"
              padding="md"
              className={isActive ? 'tab-active' : ''}
              hover={{ color: 'primary' }}
              style={{ transitionDuration: '0s', borderBottom: 0 }}
            >
              Contract SKUs
            </Box>
          )}
        </NavLink>
      </Box>
      <Box flex="auto">{warrantyType === 'contract-skus' ? <ContractSkus /> : <Warranty />}</Box>
    </Box>
  );
};
